document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;
  // select this so that when there is a secondary nav, the scroll still comes from the main nav
  const siteHeader = document.querySelector(
    ".site-header .site-header__container"
  );
  const headerHeight = siteHeader.clientHeight;

  const heroBanner = document.querySelector(".hero-banner");
  let heroBannerHeight;

  if (heroBanner) {
    heroBannerHeight = heroBanner.clientHeight;
  }

  const SCROLL_UP = "scroll-up";
  const SCROLL_DOWN = "scroll-down";
  const OUTSIDE_HERO = "outside-hero-banner";
  const INSIDE_HERO = "inside-hero-banner";
  let lastScroll = 0;

  checkPositionOnLoad();

  const ONE_HUNDREDTH_OF_A_SECOND = 10;

  const handleScroll = debounce(() => {
    const currentScroll = window.pageYOffset;
    if (currentScroll <= 0) {
      body.classList.remove(SCROLL_UP);
      return;
    }

    // general scroll up/down logic
    if (currentScroll > headerHeight) {
      if (currentScroll > lastScroll && !body.classList.contains(SCROLL_DOWN)) {
        // down
        body.classList.remove(SCROLL_UP);
        body.classList.add(SCROLL_DOWN);
      } else if (
        currentScroll < lastScroll &&
        body.classList.contains(SCROLL_DOWN)
      ) {
        // up
        body.classList.remove(SCROLL_DOWN);
        body.classList.add(SCROLL_UP);
      }
      // for case of slight scroll that removes header and does not add it back
    } else if (
      currentScroll < headerHeight &&
      body.classList.contains(SCROLL_DOWN)
    ) {
      body.classList.remove(SCROLL_DOWN);
      body.classList.add(SCROLL_UP);
      // * might need to be here,
    }

    // logic for home page header
    if (heroBannerHeight) {
      if (
        currentScroll > heroBannerHeight &&
        !body.classList.contains(OUTSIDE_HERO)
      ) {
        body.classList.add(OUTSIDE_HERO);
        if (body.classList.contains(INSIDE_HERO)) {
          body.classList.remove(INSIDE_HERO);
        }
      } else if (
        currentScroll < heroBannerHeight &&
        body.classList.contains(OUTSIDE_HERO)
      ) {
        body.classList.remove(OUTSIDE_HERO);
        if (!body.classList.contains(INSIDE_HERO)) {
          body.classList.add(INSIDE_HERO);
        }
      }
    }

    // additional home page header logic
    // when half way up, need to put the header back to its original position
    if (currentScroll < heroBannerHeight / 2) {
      if (!body.classList.contains("near-top")) {
        body.classList.add("near-top");
      }
    } else {
      if (body.classList.contains("near-top")) {
        body.classList.remove("near-top");
      }
    }

    lastScroll = currentScroll;
  }, ONE_HUNDREDTH_OF_A_SECOND);

  window.addEventListener("scroll", handleScroll);

  /**
   * Function to run on load if it is the home page to make sure header
   */
  function checkPositionOnLoad() {
    if (
      body.classList.contains("home") &&
      lastScroll < heroBannerHeight &&
      !body.classList.contains(INSIDE_HERO)
    ) {
      body.classList.add(INSIDE_HERO);
    }
  }
});

const debounce = (callback, wait) => {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback.apply(null, args);
    }, wait);
  };
};
